import { Link, useLocation } from "react-router-dom";
import { ArrowRight, Leaf, Snowflake } from "lucide-react";
import { useHoliday, THEME_STYLE } from "../../lib/holiday";

// Slim holiday strip shown at the top of the header on public pages.
export const HolidayBanner = ({ hidden }) => {
  const h = useHoliday();
  const { pathname } = useLocation();
  if (!h || hidden || pathname.startsWith("/admin") || !h.banner_text) return null;
  const s = THEME_STYLE[h.active];
  const Icon = h.active === "christmas" ? Snowflake : Leaf;
  return (
    <Link
      to="/holiday"
      data-testid="holiday-banner"
      className={`group flex items-center justify-center gap-2 px-4 py-2 text-[12px] sm:text-[12.5px] font-semibold ${s.bar} transition-opacity hover:opacity-95`}
    >
      <Icon className="h-3.5 w-3.5 shrink-0 animate-[holiday-sway_3s_ease-in-out_infinite]" />
      <span className="line-clamp-2 sm:truncate text-center">{h.banner_text}</span>
      <ArrowRight className="sm:hidden h-3.5 w-3.5 shrink-0" />
      <span className="hidden sm:inline-flex items-center gap-1 underline underline-offset-2 font-bold">
        {h.cta_label || "See deals"} <ArrowRight className="h-3 w-3 transition-transform group-hover:translate-x-0.5" />
      </span>
    </Link>
  );
};
